// src/components/AdminDashboard.jsx
import React from "react";
import TopNavbar from "../components/Gnavbar";
import BottomNavbar from "../components/BottomNavbar";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getRequest, postRequest, putRequest } from "../helpers/api.helper";
import Loader from "../components/Loader";
import { toast } from "react-toastify";

const BureauPrivacy = () => {
  const [otherbuttons, setOtherbuttons] = useState<1 | 0>(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfileSettings = async () => {
      try {
        const response = await getRequest("/bureau/settings/privacy");
        if (response.success) {
          const bureauData = response.data;
          setOtherbuttons(bureauData.showOtherProfiles);
        }
      } catch (error) {
        console.error("Error fetching profile settings:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProfileSettings();
  }, []);

  const handleSubmit = async () => {
    try {
      // Send as JSON instead of FormData for consistency
      const response = await putRequest("/bureau/settings/privacy", {
        showOtherProfiles: otherbuttons === 1 ? "show" : "hide",
        // This will be "show" or "hide"
      });
      if (response.success) {
        toast.success(response.message);
      } else {
        toast.error(response.message || "Failed to update settings");
      }
    } catch (error) {
      console.error("Error updating profile visibility settings:", error);
      toast.error("An error occurred while updating settings");
    }
  };

  // Helper function to get display text
  const getStatusText = () => {
    return otherbuttons === 1
      ? "Other profiles are currently visible"
      : "Other profiles are currently hidden";
  };

  return (
    <div className="flex flex-col h-screen">
      <TopNavbar />
      <>
        {loading ? (
          <Loader />
        ) : (
          <div className="h-auto bg-gray-100 py-10 px-4 mt-20 mb-20">
            <div className="max-w-2xl mx-auto bg-white p-8 rounded-lg shadow-lg h-auto">
              <h2 className="text-2xl font-semibold text-center text-yellow-600 mb-8">
                Profile Visibility Settings
              </h2>
              <div className="space-y-6">
                {/* Profile Visibility Toggle */}
                <div className="bg-gray-50 p-6 rounded-lg">
                  <h3 className="text-lg font-medium text-gray-800 mb-4">
                    Other Profiles Visibility
                  </h3>

                  <div className="space-y-4">
                    {/* Show Other Profiles Option */}
                    <label className="flex items-center space-x-3 cursor-pointer">
                      <input
                        type="radio"
                        name="profileVisibility"
                        checked={otherbuttons === 1}
                        onChange={() => setOtherbuttons(1)}
                        className="w-4 h-4 text-yellow-600 border-gray-300 focus:ring-yellow-500"
                      />
                      <div>
                        <span className="text-sm font-medium text-gray-900">
                          Show Other Profiles
                        </span>
                        <p className="text-xs text-gray-500">
                          Other users can see and interact with other profiles
                        </p>
                      </div>
                    </label>

                    {/* Hide Other Profiles Option */}
                    <label className="flex items-center space-x-3 cursor-pointer">
                      <input
                        type="radio"
                        name="profileVisibility"
                        checked={otherbuttons === 0}
                        onChange={() => setOtherbuttons(0)}
                        className="w-4 h-4 text-yellow-600 border-gray-300 focus:ring-yellow-500"
                      />
                      <div>
                        <span className="text-sm font-medium text-gray-900">
                          Hide Other Profiles
                        </span>
                        <p className="text-xs text-gray-500">
                          Other profiles will be hidden from view
                        </p>
                      </div>
                    </label>
                  </div>

                  {/* Current Status Indicator */}
                  <div className="mt-4 p-3 bg-yellow-50 rounded-md">
                    <p className="text-sm text-yellow-800">
                      <span className="font-medium">Current Status:</span>{" "}
                      {getStatusText()}
                    </p>
                  </div>
                </div>

                {/* Submit Button */}
                <div>
                  <button
                    onClick={handleSubmit}
                    className="w-full bg-yellow-500 hover:bg-yellow-600 text-white py-3 px-4 rounded-md font-medium transition duration-200"
                  >
                    Update Settings
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </>

      <BottomNavbar />
    </div>
  );
};

export default BureauPrivacy;
